<span class="label-and-tooltip-container">
  <span class="item-label" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <span class="property-color">
      @if (displayText) {
        {{ displayText }}
      } @else {
        {{ mod.name }}
      }
      @if (mod.originalTier && mod.originalTier !== mod.tier) {
        <span class="original-tier" (click)="resetToOriginalTier.emit(mod)"
          title="Reset to original {{ mod.originalTier }}-tier">↻</span>
      }
      @if (possiblyIncorrectSlot) {
        <span class="mod-warning icon icon-notification" title="Possibly incorrect slot"></span>
      }
      @if (noApplicableTag) {
        <span class="mod-warning icon icon-notification" title="No applicable tag"></span>
      }
    </span>

    <div class="multi-mod-info">
      @if (mod.relevantMods && mod.relevantMods.length > 0) {
        <app-mod-list [config]="{
          mods: mod.relevantMods || [],
          maxDisplayCount: 3,
          showSlots: false,
          showTags: false
        }"></app-mod-list>
      }

      @if (mod.nonRelevantMods && mod.nonRelevantMods.length > 0) {
        <app-mod-list [config]="{
          mods: mod.nonRelevantMods || [],
          maxDisplayCount: 3,
          showSlots: false,
          showTags: false,
          cssClass: 'non-relevant-mod'
        }"></app-mod-list>
      }

      @if (mod.relevantMods?.length === 0 && mod.nonRelevantMods?.length === 0) {
        <app-mod-list [config]="{
          mods: mod.mods || [],
          maxDisplayCount: 3,
          showSlots: false,
          showTags: false,
          cssClass: 'non-relevant-mod'
        }"></app-mod-list>
      }
    </div>
  </span>

  @if (!hideTooltip && showTooltip) {
    <div class="item-tooltip item-border">
      <div class="it-name">
        <h3>{{ mod.name }}</h3>
      </div>

      <div class="it-section it-effects property-value-color">
        <span>Appears as {{ mod.mods?.length }} mods</span>
        @if (itemCategory) {
          <span>, {{ mod.applicableMods?.length || 0 }} applicable to this type of {{ domain ? modDomainMap[domain] : 'item' }}</span>
        }
      </div>

      @if (mod.relevantMods?.length === 0 && mod.nonRelevantMods?.length === 0) {
        <div class="it-section it-effects">
          <div class="description multi-mod-tooltip-text non-relevant-mod">
            <app-mod-list [config]="{
              mods: mod.mods || [],
              maxDisplayCount: 10,
              showSlots: true,
              showTags: true,
              cssClass: 'non-relevant-mod'
            }"></app-mod-list>
          </div>
        </div>
      } @else {
        @if (mod.relevantMods && mod.relevantMods.length > 0) {
          <div class="it-section it-effects">
            @if (itemCategory) {
              <div class="it-effect it-property-name">Relevant to this Item Category:</div>
            }
            <div class="description multi-mod-tooltip-text">
              <app-mod-list [config]="{
                mods: mod.relevantMods || [],
                maxDisplayCount: 6,
                showSlots: true,
                showTags: true
              }"></app-mod-list>
            </div>
          </div>
        }

        @if (mod.nonRelevantMods && mod.nonRelevantMods.length > 0) {
          <div class="it-section it-effects">
            @if (itemCategory) {
              <div class="it-effect it-property-name">Not Relevant to this Item Category:</div>
            }
            <div class="description multi-mod-tooltip-text non-relevant-mod">
              <app-mod-list [config]="{
                mods: mod.nonRelevantMods || [],
                maxDisplayCount: 6,
                showSlots: true,
                showTags: true,
                cssClass: 'non-relevant-mod'
              }"></app-mod-list>
            </div>
          </div>
        }
      }
    </div>
  }
</span>
